import React, { useMemo } from "react"
import { CodeFragment, CopyButton, Property, SectionHeader } from "dash-styled"
import { FC } from "react"
import { APICollaborationModel } from "../../../../../../../../Models/API/CollaboratorModel"
import { Map } from "immutable"
import { relativeAndAbsoluteDateTime } from "../../../../../../../../Helpers/Functions/dateFormat"
import {
    AIModelForApp,
    AIModelAssignmentEnum,
    getAIModelAssignmentID
} from "../../../../../../../../Models/API/AIModel"
import { Table } from "resha"
import { aiModelUsageColumns } from "./AiModelUsageColumns"
import { metaAI } from "neql"

interface DetailSectionProps {
    className?: string
    model: AIModelForApp
    collaborators: APICollaborationModel[]
    processingAssignments: Map<AIModelAssignmentEnum, true>
    onChangeActiveness?: (
        assigned: AIModelAssignmentEnum,
        active: boolean,
        useLatestAi: boolean
    ) => void
}

export const DetailSection: FC<DetailSectionProps> = ({
    className,
    model,
    collaborators,
    processingAssignments,
    onChangeActiveness
}) => {
    const ownerEmail = collaborators.find(
        c => c.collaboratorId === model.ownerId
    )?.collaboratorEmail
    const editorEmail =
        model.editorId === undefined
            ? undefined
            : collaborators.find(c => c.collaboratorId === model.editorId)
                  ?.collaboratorEmail

    const isModelOnline =
        model.deployment?.status ===
        metaAI.Meta_Ai_Deployment_Status_Enum.Online

    const columns = useMemo(
        () =>
            aiModelUsageColumns({
                isModelOnline,
                processingAssignments,
                onChangeActiveness
            }),
        [isModelOnline, processingAssignments, onChangeActiveness]
    )

    return (
        <section className={className}>
            <SectionHeader>Details</SectionHeader>
            <dl className="pt-4">
                <Property name="Description">
                    {model.description ?? "-"}
                </Property>
                <Property name="Created">
                    {relativeAndAbsoluteDateTime(model.createdAt)}{" "}
                    {ownerEmail === undefined ? "" : `by ${ownerEmail}`}
                </Property>
                {model.updatedAt !== null && model.updatedAt !== undefined && (
                    <Property name="Last modified">
                        {relativeAndAbsoluteDateTime(model.updatedAt)}{" "}
                        {editorEmail === undefined ? "" : `by ${editorEmail}`}
                    </Property>
                )}
                <Property
                    name="UUID"
                    valueClassName="flex items-center overflow-hidden"
                >
                    <CodeFragment>{model.id}</CodeFragment>
                    <CopyButton
                        className="ml-1"
                        variant="simple"
                        value={model.id}
                    />
                </Property>
                <Property
                    name="Worker ID"
                    valueClassName="flex items-center overflow-hidden"
                >
                    <CodeFragment>{model.ai_worker_id}</CodeFragment>
                    <CopyButton
                        className="ml-1"
                        variant="simple"
                        value={String(model.ai_worker_id ?? "")}
                    />
                </Property>
                <Table
                    columns={columns}
                    getKey={getAIModelAssignmentID}
                    items={model.apps}
                />
            </dl>
        </section>
    )
}
